// src/utils/displayLabels.js
//
// Display-only localization for STORED data values (sport, gender).
// The database keeps English values ("Soccer", "Boys") — these helpers
// translate at render time so a Spanish coach reads "Fútbol · U11 ·
// Niños" while the stored data never drifts. Age-group codes (U11, 8U,
// grades) pass through untouched.

const SPORT_ES = {
  Soccer: 'Fútbol', Basketball: 'Básquetbol', Baseball: 'Béisbol',
  Softball: 'Sóftbol', Football: 'Fútbol americano', Volleyball: 'Vóleibol',
  Lacrosse: 'Lacrosse', Hockey: 'Hockey', Other: 'Otro',
};

const GENDER_ES = { Girls: 'Niñas', Boys: 'Niños', Coed: 'Mixto' };

const isEs = (lang) => String(lang || 'en').toLowerCase().startsWith('es');

export function sportLabel(sport, lang) {
  if (!sport) return sport;
  return isEs(lang) ? (SPORT_ES[sport] || sport) : sport;
}

export function genderLabel(gender, lang) {
  if (!gender) return gender;
  return isEs(lang) ? (GENDER_ES[gender] || gender) : gender;
}

/** "Fútbol · U11 · Niños" — skips missing parts. */
export function teamMetaLine(team, lang) {
  return [
    sportLabel(team?.sportType || team?.sport, lang),
    team?.ageGroup,
    genderLabel(team?.gender, lang),
  ].filter(Boolean).join(' · ');
}
